import type { ProductSpecificsFormValues } from "../components/productFormSchema"

import type { ProductUpdateInput } from "@/graphql/codegen/graphql"
import { ProductFormInfoItem } from "@/graphql/codegen/graphql"

export const toProductSpecificsUpdateInput = (
  productId: number,
  formValues: Partial<ProductSpecificsFormValues>
): ProductUpdateInput => ({
  productId,
  classificationId: formValues.classification,
  productFormInfo: formValues.productFormInfo
    ? ProductFormInfoItem[formValues.productFormInfo as keyof typeof ProductFormInfoItem]
    : undefined,
  uomId: formValues.uomId,
})
